export default {
	NONE: '',
	SAVING: 'SAVING',
	UNLINKING: 'UNLINKING',
}
